import { Component, Input } from '@angular/core';

@Component({
  selector: 'era-title-h4',
  templateUrl: './title-h4.component.html',
  styleUrls: ['./title-h4.component.scss'],
})
export class TitleH4Component {
  @Input() isDetail = false;
}
